module.exports = __webpack_public_path__ + "static/media/2.9440d4f5.svg";